import React, {Component} from 'react';
import {nutritions} from '../../../server/constants.js';
import ReactTable from 'react-table';
import { BeatLoader } from 'react-spinners';
import NutritionInfoTable from './NutritionInfoTable'
import { get, postWithHeaders } from '../../../server/actions'
import NotificationSystem from 'react-notification-system';
import {_addNotification,_addNotificationError,} from "../../../server/util";

class NutritionPage extends Component {
    constructor(props){
        super(props);
        this.state={
            loading: false,
            headers : [],
            data : [],
            assignedArray:[],
            unAssignedArray : [],
            dropdownVal:'',
            notOrdered : nutritions

        }
    }
    _addNotification(event) {
        this._notificationSystem.addNotification({
            title: "Failed",
            message: 'Something went wrong, Please try again later',
            level: 'error',
            position: 'tc',
            autoDismiss: '5',
            uid: 5,

        });
    }
    _addSuccessNotification(message) {
        this._notificationSystem.addNotification({
            title: "Success",
            message: message,
            level: 'success',
            position: 'tc',
            autoDismiss: '5',
            uid: 5,

        });
    }
    componentDidMount = () => {
        
        this._notificationSystem = this.refs.notificationSystem;
        let headers = [
            {
                Header: "Item Name", style: { textTransform: 'capitalize'},width:150, accessor: 'name'
            }
        ]
        const sortable = Object.entries(this.state.notOrdered)
            .sort((a,b) => a[1].tabindex-b[1].tabindex)
            .reduce((r, [k, v]) => ({ ...r, [k]: v }), {});
        console.log(sortable)
        Object.keys(sortable).forEach(item=>{
           
            const column = {Header: nutritions[item].display.replace("*",''),nutritionName : item}
            headers.push(column)
        })
        console.log(headers)
        this.getItems()
        this.setState({headers})
    }
    getItems = () => {
        let month = new Date().getMonth()+1
        let year = new Date().getFullYear()
        let yearMonth = year.toString() + (month < 10 ? "0"+month : month)
        this.setState({loading: true});
            get(`/menuItems/search/findByActiveAndSchoolDetailsSchoolId?yearMonth=${yearMonth}&isActive=true&schoolId=${sessionStorage.getItem('SchoolId')}&access_token=`).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
            
        }).then(data=>{
            const menuItems = data._embedded.menuItems
            var assignedArray = menuItems.filter(item=>item.isNutrAvailable)
            var unAssignedArray = menuItems.filter(item=>!item.isNutrAvailable)
            this.setState({data:[...assignedArray,...unAssignedArray],assignedArray,unAssignedArray})
            this.setState({loading: false});
        }).catch(err=>{
            console.log(err)
        })
    
    };
    inputTextBox=(props,name,rowIndex)=>{
        const val = props[name] ? props[name] : '' 
        return (<input type="text" className="form-control col-xs" value={val}  onChange={(e)=>this.updateValue(e,name,props,rowIndex)}/>)
    }
    updateValue=(e,name,props,rowIndex)=>{
        this.state.data[rowIndex][name] = parseInt(e.target.value)
        this.state.data[rowIndex]['isChangedData'] = true
        this.setState({data:[...this.state.data]})
        console.log(e.target.value,name,props,rowIndex)
    }
    saveData = ()=>{
        var requestBody = this.state.data.filter(item=> item.isChangedData )
        //console.log(requestBody)
        requestBody.forEach(item=> {
            var urlArray = item._links.menuItem.href.split('/')
            var lastIndex = urlArray.length -1
            item.itemId = parseInt(urlArray[lastIndex])
            delete item._links
            
            delete item.isChangedData
        })

        if(requestBody.length>0){
            let headers = {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            };
            postWithHeaders(`/${sessionStorage.getItem('SchoolId')}/nutritionInfo?access_token=`,JSON.stringify(requestBody),headers).then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                console.log('response', response);
                return response.json();
            }).then(data => {
                console.log(data)
               this._addSuccessNotification()
            }).catch(
                (error) => {
                    this._addNotification();
                    console.log(' response', error)
                }
            )
        }
    }
    filterData = (val) =>{
       // const val = e.target.value
       this.setState({loading: true});
        if(val === "assigned"){
            this.setState({data:this.state.assignedArray,dropdownVal:val})

        }else if(val === "unassigned"){
            this.setState({data:this.state.unAssignedArray,dropdownVal:val})
        }else{
            this.setState({data:[...this.state.assignedArray,...this.state.unAssignedArray],dropdownVal:val})
        }
        this.setState({loading: false});
    }
    filterItemName=(e)=>{
        const val = e.target.value
        var tabledata=[]
        if(val){
            this.setState({loading: true});
            if(this.state.dropdownVal==="assigned"){
                tabledata = this.state.assignedArray
            }else if(this.state.dropdownVal==="unassigned"){
                tabledata = this.state.unAssignedArray
            }else{
                tabledata = [...this.state.assignedArray,...this.state.unAssignedArray]
            }
            const searchdata = tabledata.filter(item => item.name.toLowerCase().includes(val.toLowerCase()))
            this.setState({data:searchdata,loading: false})
        }else{
           this.filterData(this.dropdownVal)
        }
       
    }
    render() {
        return (
        <div>
            <NotificationSystem ref="notificationSystem" />
            <div className='sweet-loading'
                style={{ position: 'fixed', top: '50%', left: '48%', zIndex: '1000' }}>
                <BeatLoader
                    size={20}
                    color={'#ea7066'}
                    loading={this.state.loading}
                />
            </div>
            <div className="container">
                <div className="row">
                    <div className="col-md-8 col-sm-12 col-xs-12 sectionTitle">
                        <h2>
                        <select className="col-xs-4" id="filter" onChange={(e)=>this.filterData(e.target.value)} >
                                <option  selected value>All</option>                               
                                <option   value="assigned">Available</option>                               
                                <option   value="unassigned">Missing</option>                               
                                
                            </select> 
                        </h2>
                    </div>
                    <div className="col-md-4 col-sm-12 col-xs-12 " style={{paddingTop:20}}>
                        <input type="text" placeholder="Search item" onChange={(e)=>this.filterItemName(e)} className="form-control" />
                    </div>
                </div>
                
                <NutritionInfoTable 
                    data={this.state.data}
                    headers = {this.state.headers}
                    saveData = {this.saveData}
                    updateValue={this.updateValue}

                />
            </div>
        </div>
                   
        );
    }
}
export default NutritionPage;


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/Nutrition/NutritionPage.jsx